// Avatar with serif initial. Color tints from the brand palette only:
// "rust" | "sage" | "gold" | "ink" | a CSS color string.

const PRESETS = {
  rust: "var(--rust)",
  sage: "var(--sage)",
  gold: "var(--gold-500)",
  ink:  "var(--ink-800)",
};

export default function Avatar({ initials = "?", color = "rust", size = 36, ringColor, style, ...rest }) {
  const bg = PRESETS[color] || color;
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        background: bg,
        color: "#fff",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: '"Baloo 2", "Nunito", sans-serif',
        fontWeight: 800,
        fontSize: size * 0.44,
        lineHeight: 1,
        flexShrink: 0,
        border: ringColor ? `2px solid ${ringColor}` : undefined,
        ...style,
      }}
      {...rest}
    >
      {String(initials).slice(0, 2).toUpperCase()}
    </span>
  );
}
